import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import React from "react";
import type { DropdownMenuPortalProps } from "../types";

function DropdownMenuPortal(props: DropdownMenuPortalProps) {
  return (
    <DropdownMenuPrimitive.Portal data-slot="dropdown-menu-portal" {...props} />
  );
}

DropdownMenuPortal.displayName = "DropdownMenu.Portal";

export default DropdownMenuPortal;
